/// <reference path="IP.Validation.js" />

// Valideringsfunktioner

// When pressing next, on any page, the focus will shift to the first error on the page.
const nextButton = document.querySelector('#btnNaeste') ?? document.querySelector('.btn-next');
nextButton?.addEventListener('click', () => {
    Array.from(document.querySelectorAll('.error'))
        .find(e => window.getComputedStyle(e).display !== 'none')
        ?.scrollIntoView();
});

// always returns false
window.setValidationError = function (elem, tekst) {
    if (!(elem instanceof jQuery)) {
        elem = $(elem);
    }
    elem.nextAll('div.error').show();
    elem.closest('div.fu').addClass('error');
    if (tekst) {
        elem.nextAll('div.error').find('p').text(tekst);
    }
    return false; // always false!
};

window.setValidationWarning = function (elem, tekst) {
    if (!(elem instanceof jQuery)) {
        elem = $(elem);
    }
    elem.nextAll('div.note').show();
    elem.closest('div.fu').addClass('note');
    if (tekst) {
        elem.nextAll('div.note').find('p').text(tekst);
    }
    return false; // always false!
};

window.setValidationInfo = function (elem) {
    if (!(elem instanceof jQuery)) {
        elem = $(elem);
    }

    elem.nextAll('div.info').show();
    const fu = elem.closest('div.fu');
    if (!fu.hasClass('errorstatic')) {
        fu.removeClass('error');
    }
};

window.removeValidationInfo = function (elem) {
    if (!(elem instanceof jQuery)) {
        elem = $(elem);
    }

    elem.nextAll('div.info').hide();
    const fu = elem.closest('div.fu');

    if (!fu.hasClass('infostatic')) {
        fu.removeClass('info');
    }
};

window.isElementInError = function () {
    if (!(elem instanceof jQuery)) {
        elem = $(elem);
    }
    if (elem.closest('div.fu').hasClass('error')) {
        return true;
    } else {
        return false;
    }
};

window.clearValidationMessage = function (elem) {
    window.setValidationOk(elem);
};

// alwasy returns true
window.setValidationOk = function (elem) {
    if (!(elem instanceof jQuery)) {
        elem = $(elem);
    }
    elem.next('div.error.msg').hide();
    elem.nextAll('div.note').hide();
    elem.nextAll('div.info').hide();
    const fu = elem.closest('div.fu');
    fu.removeClass('note');
    fu.find('div.error.msg, div.note, div.info').hide();

    if (!fu.hasClass('errorstatic')) {
        fu.removeClass('error');
    }
    if (!fu.hasClass('infostatic')) {
        fu.removeClass('info');
    }
    return true; // always true!
};

// Benyttet til bla. kampagnebokse
window.validateEmail = function (elem, tekst) {
    elem = $(elem);
    const email = getInputValue(elem);
    const regEx = /^\s*[_a-z0-9-A-Z]+(\.[_a-z0-9-A-Z]+)*@[a-z0-9-A-Z-]+(\.[a-z0-9-A-Z-]+)*(\.[a-z]{2,5})\s*$/;
    if (email.length > 0) {
        if (regEx.test(email.trim())) {
            // korrekt format
            return setValidationOk(elem);
        } else {
            if (tekst) {
                return setValidationError(elem, tekst);
            } else {
                return setValidationError(elem);
            }
        }
    }
    return setValidationOk(elem);
};

window.validateEmailRequired = function (elem) {
    elem = $(elem);
    const email = getInputValue(elem);
    if (email.length == 0) {
        return false;
    } else {
        return validateEmail(elem);
    }
};

window.validateEmailLengthMax50 = function (elem) {
    elem = $(elem);
    const email = elem.val();
    if (email.trim().length > 50) {
        return false;
    } else {
        return true;
    }
};

window.validateEmailIPS2025 = function (elem, tekst) {
    elem = $(elem);
    const email = getInputValue(elem);
    const regEx = /^(\w|[æøåÆØÅ])+(\w|[æøåÆØÅ]|\.|-|_)*(\w|[æøåÆØÅ])@([a-zA-Z]|[æøåÆØÅ])+(\.[a-zA-Z]{2,5})+$/;
    if (email.length > 0) {
        if (regEx.test(email.trim())) {
            // korrekt format
            return setValidationOk(elem);
        } else {
            if (tekst) {
                return setValidationError(elem, tekst);
            } else {
                return setValidationError(elem);
            }
        }
    }
    return setValidationOk(elem);
};

// Benyttet til bla. kampagnebokse
window.validateMobile = function (elem) {
    elem = $(elem);
    const mobileNr = getInputValue(elem);
    // Forskellen på valideringen på telefon validering og på mobilvalidering er at der for mobiltelefonnumre ikke tillades
    const regEx = /^((\+\s?[1-9]{1,3})|(0[0-9][0-9][0-9]))?\s?[1-9](\s?\d){7,22}$/;
    if (mobileNr.length > 0) {
        if (regEx.test(mobileNr)) {
            // korrekt format, nu edit outformat
            setValidationOk(elem);

            const tlfnr = mobileNr.replace(/\s/g, '');
            let tlfOut;

            if (tlfnr.length == 8) {
                // "normal" telefonnr.
                tlfOut = `${tlfnr.substring(0, 2)} ${tlfnr.substring(2, 4)} ${tlfnr.substring(4, 6)} ${tlfnr.substring(6, 8)}`;
            }
            // 11 = +45 foran...
            else if (tlfnr.length == 11) {
                tlfOut = `${tlfnr.substring(0, 3)} ${tlfnr.substring(3, 5)} ${tlfnr.substring(5, 7)} ${tlfnr.substring(7, 9)} ${tlfnr.substring(9, 11)}`;

            }
            // 12 = 0045 foran..
            else if (tlfnr.length == 12) {
                tlfOut = `${tlfnr.substring(0, 4)} ${tlfnr.substring(4, 6)} ${tlfnr.substring(6, 8)} ${tlfnr.substring(8, 10)} ${tlfnr.substring(10, 12)}`;
            }
            else {
                // Default.. kan ikke style den rigtigt ?
                tlfOut = tlfnr;
            }

            elem.val(tlfOut);
            return true;
        } else {
            return setValidationError(elem);
        }
    } else {
        return setValidationOk(elem);
    }
};

window.validateMobileRequired = function (elem) {
    elem = $(elem);
    const mobileNr = getInputValue(elem);
    if (mobileNr.length == 0) {
        setValidationError(elem);
        return false;
    }

    return validateMobile(elem);
};

// format: 26.12.19 || 26.12.2019 || 26-12-19 || 26-12-2019
window.validateDateRequired = function (elem, minDateString, maxDateString) {
    const el = $(elem);
    const datestr = getInputValue(el);

    if (datestr.length == 0) {
        setValidationError(el);
        return false;
    }

    return validateDate(elem, minDateString, maxDateString);
};

window.validateDate = function (elem, minDateString, maxDateString) {
    const el = $(elem);
    const datestr = getInputValue(el);
    if (datestr.length > 0) {
        const dt = ipStringToDate(datestr);
        if (!(dt instanceof Date) && isNaN(dt)) {
            return setValidationError(el);
        }
        if (minDateString) {
            if (dt < new Date(minDateString)) {
                return setValidationError(el);
            }
        }
        if (maxDateString) {
            if (dt > new Date(maxDateString)) {
                return setValidationError(el);
            }
        }
    }
    return setValidationOk(elem);
};

window.ipStringToDate = function (ipstringdate) {
    ipstringdate = ipstringdate.replace('-', '.');
    const split = ipstringdate.split('.');

    return new Date(split[2], (split[1] - 1), split[0]);
};

window.validateTelefonRequired = function (elem) {
    elem = $(elem);
    const mobileNr = getInputValue(elem);
    if (mobileNr.length == 0) {
        setValidationError(elem);
        return false;
    }
    return validateTelefon(elem);
};

window.validateTelefon = function (elem) {
    elem = $(elem);
    const telNr = getInputValue(elem);
    const regEx = /^((\+\s?[1-9]\d{1,2})|(00[1-9][0-9]))?\s?[0-9](\s?\d){7,22}$/;
    if (telNr.length > 0) {
        if (regEx.test(telNr)) {
            // korrekt format, nu edit outformat
            setValidationOk(elem);

            const tlfnr = telNr.replace(/\s/g, '');
            let tlfOut;

            if (tlfnr.length === 8) {
                // "normal" telefonnr.
                tlfOut = `${tlfnr.substring(0, 2)} ${tlfnr.substring(2, 4)} ${tlfnr.substring(4, 6)} ${tlfnr.substring(6, 8)}`;
            }
            // 11 = +45 foran...
            else if (tlfnr.length == 11) {
                tlfOut = `${tlfnr.substring(0, 3)} ${tlfnr.substring(3, 5)} ${tlfnr.substring(5, 7)} ${tlfnr.substring(7, 9)} ${tlfnr.substring(9, 11)}`;

            }
            // 12 = 0045 foran..
            else if (tlfnr.length === 12) {
                tlfOut = `${tlfnr.substring(0, 4)} ${tlfnr.substring(4, 6)} ${tlfnr.substring(6, 8)} ${tlfnr.substring(8, 10)} ${tlfnr.substring(10, 12)}`;
            }
            else {
                // Default.. kan ikke style den rigtigt ?
                tlfOut = tlfnr;
            }

            elem.val(tlfOut);
            return true;
        } else {
            return setValidationError(elem);
        }
    } else {
        return setValidationOk(elem);
    }
};

// Required input
window.validateRegNr = function (elem) {
    elem = $(elem);
    const regnr = getInputValue(elem);
    const regEx = /^\d{4}$/;
    const errElem = elem.next('div.error');

    if (regnr.length > 0) {
        if (regEx.test(regnr)) {
            // korrekt format
            return setValidationOk(elem);
        } else {
            // Forkert format
            $(':first-child', errElem).hide();
            $(':last-child', errElem).show();
            errElem.show();
            elem.closest('div.fu').addClass('error');
        }
    } else {
        $(':first-child', errElem).show();
        $(':last-child', errElem).hide();
        errElem.show();
        elem.closest('div.fu').addClass('error');
    }
    return false;
};

// Validerer kontonr
// konto nr er Required!
window.validateKontoNr = function (elem) {

    elem = $(elem);
    const konto = getInputValue(elem);
    const regEx = /^\d{0,10}$/;
    const errElem = elem.next('div.error');

    if (konto.length > 0) {
        if (regEx.test(konto)) {
            // korrekt format
            setValidationOk(elem);

            if (konto.length < 10) {
                let leadingZeros = '';
                const leng = 10 - konto.length;
                for (let i = 0; i < leng; i++) {
                    leadingZeros += '0';
                }
                const kontoPrefixed = leadingZeros + konto;
                elem.val(kontoPrefixed);
            }

            return true;
        } else {
            // Forkert format
            $(':first-child', errElem).hide();
            $(':last-child', errElem).show();
            errElem.show();
            elem.closest('div.fu').addClass('error');
        }
    } else {
        // Obligatorisk felt
        $(':first-child', errElem).show();
        $(':last-child', errElem).hide();
        errElem.show();
        elem.closest('div.fu').addClass('error');
    }
    return false;
};

window.validateOnlyLetters = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^[A-z]+$/;
    const errElem = elem.next('div.error');

    if (regEx.test(input)) {
        // korrekt format
        return setValidationOk(elem);
    } else {
        // Forkert format
        $(':first-child', errElem).hide();
        $(':last-child', errElem).show();
        errElem.show();
        elem.closest('div.fu').addClass('error');
        return false;
    }
};

window.validateOnlyDkLetters = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^[a-zA-ZæøåéÆØÅÉ]+$/;
    const errElem = elem.next('div.error');

    if (regEx.test(input)) {
        // korrekt format
        return setValidationOk(elem);
    } else {
        // Forkert format
        $(':first-child', errElem).hide();
        $(':last-child', errElem).show();
        errElem.show();
        elem.closest('div.fu').addClass('error');
        return false;
    }
};

window.validateOnlyDkLettersOneWhiteSpaceAllowed = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^[a-zA-ZæøåéÆØÅÉ]+( [a-zA-ZæøåéÆØÅÉ]+)*$/;
    const errElem = elem.next('div.error');

    if (regEx.test(input)) {
        // korrekt format
        return setValidationOk(elem);
    } else {
        // Forkert format
        $(':first-child', errElem).hide();
        $(':last-child', errElem).show();
        errElem.show();
        elem.closest('div.fu').addClass('error');
        return false;
    }
};

window.modulus11Cpr = function (elem) {
    elem = $(elem);
    const valid = {
        cpr: validateCprLogic(elem)
    };
    removeValidationInfo(elem);
    if (valid.cpr) {
        const cpr = getInputValue(elem).replace(/-/g, '');
        let chk = 0;
        for (let i = 9; i > -1; i--) {
            chk += (+cpr.charAt(i)) * ((i > 2) ? (10 - i) : (4 - i));
        }
        if (chk % 11 === 0) {
            removeValidationInfo(elem);
            valid.modulus11 = true;
        } else {
            setValidationInfo(elem);
            valid.modulus11 = false;
        }
    }
    return valid;
};

window.validateCpr = function (elem) {
    return validateCprLogic(elem);
};

window.validateCprPensionsplan2022 = function (elem) {
    return validateCprLogic(elem);
};

window.validateCprLogic = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^[0-3][0-9][0-1][0-9]\d{2}-?\d{4}$/;
    if (regEx.test(input)) {
        return setValidationOk(elem);
    }
    console.warn('CPR validering fejlede for input:', input);
    return setValidationError(elem);
};

window.validateSwift = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^([A-Z]){4}([A-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;
    if (regEx.test(input)) {
        return setValidationOk(elem);
    }
    return setValidationError(elem);
};

window.validateIBAN = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^(([A-Z]){2}([0-9]){2}([0-9A-Z]){0,30})?$/;
    if (regEx.test(input)) {
        setValidationOk(elem);
        return true;
    }
    return setValidationError(elem);
};

window.validateUdenlandskKontonummer = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^([0-9a-zA-Z]){0,34}?$/;
    if (regEx.test(input)) {
        return setValidationOk(elem);
    }
    return setValidationError(elem);
};

window.validateCvr = function (elem) {
    elem = $(elem);
    const input = getInputValue(elem);
    const regEx = /^\d{8}$/;
    return (regEx.test(input));
};

// Metoder der returnerer '' (string.empty) såfremt brugeren ikke har indtastet noget.. ellers returneres placeholderværdien ("indtast email...")
window.getInputValue = function (elem) {
    const $this = elem;
    const val = $this.eq(0).val();
    return (val == $this.attr('placeholder')) ? '' : val;
};

// required
// min 1 max 50
// no numbers
window.validateName = function (elem) {
    elem = $(elem);
    const minlength = 1;
    const maxlength = 50;
    const regex = /^(\D*)$/;
    const name = getInputValue(elem);
    if (name.length < minlength || name.length > maxlength) {
        return setValidationError(elem);
    }
    if (!regex.test(name)) {
        return setValidationError(elem);
    }
    return setValidationOk(elem);
};

// pensionsplan2022 full name validation.
window.validateFullName = function(elem, min, max) {
    elem = $(elem);
    const minlength = min;
    const maxlength = max;
    // The Regex below matches full names.
    // The regex allows for letters a required space and more leters and space and ' Can not end on an space
    // Example of valid name "Æskild Klar'skov hansen"
    const regex = /^[a-zA-ZæøåÆØÅ'-]+\s[a-zA-ZæøåÆØÅ'-]+(?:\s[a-zA-ZæøåÆØÅ'-]+)*$/;
    const name = getInputValue(elem);
    if (name.length < minlength || name.length > maxlength) {
        return setValidationError(elem);
    }
    if (!regex.test(name)) {
        return setValidationError(elem);
    }
    return setValidationOk(elem);
};

// just required
window.validateAddress = function (elem) {
    if (!required(elem)) {
        setValidationError(elem);
        return false;
    }
    return setValidationOk(elem);
};

// 4 digits - no more no less
window.validatePostalcodeDK = function (elem) {
    elem = $(elem);
    const regex = /^[0-9]{4}$/;
    const postal = getInputValue(elem);
    if (!regex.test(postal)) {
        setValidationError(elem);
        return false;
    }
    return setValidationOk(elem);
};

window.validatePostalcodeWorld = function (elem) {
    elem = $(elem);
    if (!required(elem)) {
        return setValidationError(elem);
    }
    return setValidationOk(elem);
};

// required
// min 1 max 50
// no numbers
window.validateTown = function (elem) {
    elem = $(elem);
    const minlength = 1;
    const maxlength = 50;
    const regex = /^(\D*)$/;
    const town = getInputValue(elem);
    if (town.length < minlength || town.length > maxlength) {
        return setValidationError(elem);
    }
    if (!regex.test(town)) {
        return setValidationError(elem);
    }
    return setValidationOk(elem);
};

// required
// min 1 max 50
// no numbers
window.validateContry = function(elem) {
    elem = $(elem);
    const minlength = 1;
    const maxlength = 50;
    const regex = /^(\D*)$/;
    const contry = getInputValue(elem);
    if (contry.length < minlength || contry.length > maxlength) {
        return setValidationError(elem);
    }
    if (!regex.test(contry)) {
        return setValidationError(elem);
    }
    return setValidationOk(elem);
};

// just required base - length GT 0
window.required = function (elem) {
    elem = $(elem);
    const element = getInputValue(elem);
    return element.length > 0;
};

window.validateRequiredField = function (elem) {
    elem = $(elem);
    const element = getInputValue(elem);
    if (element.length === 0) {
        return setValidationError(elem);
    }
    return setValidationOk(elem);
};

window.ValidateTextField = function (elem, minlength, maxlength) {
    elem = $(elem);
    const theValue = getInputValue(elem);
    if (theValue) {
        return (theValue.length > minlength && theValue.length < maxlength);
    }
};

window.validateRequiredRadioBtn = function (elemname) {
    const btns = $('input[name="' + elemname + '"]');
    if (btns.is(':checked')) {
        btns.each(function () {
            setValidationOk(this);
        });

        return true;
    } else {
        btns.each(function () {
            setValidationError(this);
        });
        return false;
    }
};

window.validateRequiredRadioBtnBySelector = function (selector) {
    let retval = true;
    const btns = $(selector);
    const uniqueIdsArr = [];

    btns.each(function () {
        if (!~$.inArray(this.id, uniqueIdsArr)) {
            uniqueIdsArr.push(this.id);
        }
    });
    $.each(uniqueIdsArr, function (index, value) {
        if ($('input:radio[id=' + value + ']:checked').length == 0) {
            setValidationError('input:radio[id=' + value + ']');
            retval = false;
        } else {
            setValidationOk('input:radio[id=' + value + ']');
        }
    });

    return retval;
};


window.validateRequiredCheckboxBySelector = function (selector) {
    let retval = true;
    const btns = $(selector);
    const uniqueIdsArr = [];

    btns.each(function () {
        if (!~$.inArray(this.value, uniqueIdsArr)) {
            uniqueIdsArr.push(this.value);
        }
    });
    $.each(uniqueIdsArr, function (index, value) {
        if ($('input:checkbox[value=' + value + ']:checked').length == 0) {
            retval = false;
        }
    });
    if (retval == false) {
        $.each(uniqueIdsArr, function (index, value) {
            setValidationError('input:checkbox[value=' + value + ']');
        });
    }

    return retval;
};


(function () {

    const cleanedValue = (value) => value.replace(/[\s\u00A0]/g, '');
    const isOnlyDigits = (value) => /^\d+$/.test(value);

    window.validateCprOrBirthday = function (elem) {
        const jElem = $(elem);
        const value = getInputValue(jElem).trim();

        if (validateCprLogic(elem)) {
            return modulus11Cpr(elem);
        }
        const cleaned = cleanedValue(value);
        if (cleaned.length == 6 && isOnlyDigits(cleaned)) {
            return setValidationOk(elem);
        }

        return setValidationError(elem);
    };


    function cleanNumber(value) {
        if (!value) {
            return '';
        }
        // Erstatter alle (\s) og non-breaking spaces (\u00A0) globalt (g)
        return value.replace(/[\s\u00A0]/g, '');
    }
    function isValidNumber8or10Format(cleanedValue) {
        const onlyDigits = /^\d+$/.test(cleanedValue);
        const validLength = (cleanedValue.length === 8 || cleanedValue.length === 10);

        return onlyDigits && validLength;
    }

    window.validateCvrOrPno = function (elem) {
        elem = $(elem);
        const value = getInputValue(elem);

        const cleanValue = cleanNumber(value);

        if (isValidNumber8or10Format(cleanValue)) {
            return setValidationOk(elem);
        }
        return setValidationError(elem);
    };

})();
